// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__3pmB0","reportBodyText":"style__reportBodyText__eDA9t"};